/** @format */

import React, { useState, useMemo, useCallback, useEffect } from "react";

import { getTaxPayer } from "../../api/taxPayer/getTaxPayer/index.js";
import { getAccrualPdf } from "../../api/accrual/getAcrrualPdf/index.js";
import FilterDrawer from "../../components/FilterDrawer/index.js";

import { useParams } from "react-router-dom";
import Swal from "sweetalert2";
import Sidebar from "../../components/sideBar/sideBar.js";
import Navbar from "../../components/navbar/navbar.js";
import gridSideBar from "../../components/GridSideBar/gridSideBar.js";
import createColumnDefs from "./columnDefs.js";
import localStorage from "local-storage";
import {
  Grid,
  Typography,
  Pagination,
  TextField,
  MenuItem,
  Drawer,
  Box,
} from "@mui/material";

import { AgGridReact } from "ag-grid-react";
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-quartz.css";
import localeTextTr from "../../locale.tr.js";
import { createTurkishFilterParams } from "../../utils/agGridTextFilterTr/agGridFilterUtils.js";
import { getWaitingDeclarationList } from "../../api/declaration/getWaitingDeclarationList/index.js";
import NoteModal from "./editModal.js";

function StatusWaitingTaxPayerPage() {
  const [selectedPdfData, setSelectedPdfData] = useState(null);

  const [reload, setReload] = useState(true);
  const [taxPayerData, setTaxPayerData] = useState([]);
  const [openDrawer, setOpenDrawer] = useState(false);

  const { id } = useParams();
  const [data, setData] = useState([]);
  const [isOpen, setIsOpen] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPage, setTotalPage] = useState(1);
  const [pageSize, setPageSize] = useState(50);
  const [totalCount, setTotalCount] = useState(0);

  const [loading, setLoading] = useState(false);

  const [filters, setFilters] = useState({
    status: null,
    systemStatus: null,
    types: [],
    mailStatus: null,
  });

  useEffect(() => {
    setTimeout(clearLocalStorage, 10 * 60 * 1000);

    getTaxPayer(id)
      .then((resp) => {
        setTaxPayerData(resp.data.data);
        getWaitingDeclarationList(resp.data.data?.id, currentPage, pageSize)
          .then((resp) => {
            setData(resp.data.data);
            setTotalPage(resp.data.totalPage);
            setTotalCount(resp.data.totalCount);
            // console.log(resp.data.data, "datae");
          })
          .catch((err) => {
            Swal.fire({
              title: err.response.data.message,
              icon: "error",
              confirmButtonText: "Tamam",
            });
          });
      })
      .catch((error) => {
        // console.log(error.response.data, "burası olabilir");
        Swal.fire({
          title: error.response.data.message,
          icon: "error",
          confirmButtonText: "Yenile",
          cancelButtonText: "Tamam",
          showCancelButton: true,
        }).then((response) => {
          if (response.isConfirmed) {
            setReload(!reload);
          }
        });
      });
  }, [reload, currentPage, pageSize]);

  // const onSelectionChanged = (event) => {
  //   const selectedNodes = event.api.getSelectedNodes();
  //   const selectedIds = selectedNodes.map((node) => node.data.id);
  //   const selectedData = selectedNodes.map((node) => node.data);
  //   setSelectedData(selectedData);
  //   setSelectedIds(selectedIds);
  // };

  useEffect(() => {
    const lastPage = localStorage.get("page");
    const lastPageSize = localStorage.get("pageSize");
    const sideBarOpen = localStorage.get("sidebar");

    if (sideBarOpen === "false") {
      setIsOpen(false);
    } else {
      setIsOpen(true);
    }

    if (lastPage) {
      setCurrentPage(lastPage);
    }
    if (lastPageSize) {
      setPageSize(lastPageSize);
    }

    const cleanupLocalStorage = () => {
      localStorage.clear();
    };
    window.addEventListener("beforeunload", cleanupLocalStorage);
    return () => {
      window.removeEventListener("beforeunload", cleanupLocalStorage);
    };
  }, []);
  function clearLocalStorage() {
    localStorage.clear();
  }
  const toggleSidebar = () => {
    setIsOpen(!isOpen);
  };
  const [modalOpen, setModalOpen] = useState(false);
  const [selectedNote, setSelectedNote] = useState("");
  const [selectedRowId, setSelectedRowId] = useState(null);

  const handleNoteClick = (note, rowId) => {
    setSelectedNote(note);
    setSelectedRowId(rowId);
    setModalOpen(true);
  };

  const defaultColDef = useMemo(
    () => ({
      flex: 1,
      minWidth: 100,
      filter: true,
      sortable: true,
      resizable: true,
      floatingFilter: true,
      filterParams: createTurkishFilterParams(),
    }),
    []
  );

  const [rowData, setRowData] = useState();

  const detailCellRendererParams = useMemo(() => {
    return {
      detailGridOptions: {
        defaultExpanded: false,
        // sideBar={gridSideBar},
        // rowSelection: "multiple",
        // suppressRowClickSelection: true,
        enableRangeSelection: true,
        // paginationAutoPageSize: true,
        columnDefs: [{ field: "description" }],
        defaultColDef: {
          flex: 3,
          maxWidth: 300,
          resizable: true,
          floatingFilter: true,
          suppressMenu: false, // Allow menu in detail grid columns
        },
      },
      getDetailRowData: (params) => {
        params.successCallback(params.data.subDetails);
      },
    };
  }, []);

  const search = () => {
    getWaitingDeclarationList(id, currentPage, pageSize)
      .then((resp) => {
        setData(resp.data.data);
        setTotalPage(resp.data.totalPage);
        setTotalCount(resp.data.totalCount);
        // console.log(data, "data");
      })
      .catch((err) => {
        Swal.fire({
          title: err.response.data.message,
          icon: "error",
          confirmButtonText: "Tamam",
        });
      });
  };

  const handlePdfClick = async (rDriveID, note, rowId) => {
    setLoading(true);
    Swal.fire({
      title: "PDF Yükleniyor",
      text: "Lütfen Bekleyiniz...",
      allowOutsideClick: false,
      allowEscapeKey: false,
      allowEnterKey: false,
      didOpen: () => {
        Swal.showLoading(); // Yükleme simgesini göster
      },
    });

    await getAccrualPdf(rDriveID)
      .then((resp) => {
        Swal.close();
        setLoading(false);
        setSelectedPdfData(resp.data.pdfBase64);
        setSelectedNote(note);
        setSelectedRowId(rowId);
        setModalOpen(true);
      })
      .catch((err) => {
        Swal.close();
        setLoading(false);
        Swal.fire({
          text: "PDF yüklenirken bir hata oluştu",
          icon: "error",
          confirmButtonText: "Tamam",
        });
      });
  };

  const ColumnDefs = createColumnDefs(handlePdfClick, handleNoteClick);

  const onGridReady = useCallback((params) => {
    setRowData(data);
  }, []);

  return (
    <Grid container>
      <Grid
        item
        sx={{
          flexBasis: isOpen ? "275px" : "95px",
          flexShrink: 0,
          transition: "flex-basis 0.3s ease", // Düzeltilmiş transition
        }}
      >
        <Sidebar status={isOpen} toggleSidebar={toggleSidebar} />
      </Grid>

      <Grid
        item
        sx={{
          flex: 1,
          display: "flex",
          justifyContent: "flex-end",
          flexDirection: "column",
          gap: 1,
          pr: "12px",
        }}
      >
        <Grid item xs={12}>
          <Navbar />
        </Grid>
        <Grid item md={12} sx={{ display: "flex", flexDirection: "column" }}>
          <Grid item md={12} sx={{ mt: 1, mb: 1 }}>
            <Box
              sx={{
                border: "1px solid #ccc", // Kenarlık rengi
                borderRadius: "8px", // Köşeleri yuvarlama
                padding: "16px", // İçerik dolgulama
                backgroundColor: "white", // Arka plan rengi
                boxShadow: "0px 4px 12px rgba(0, 0, 0, 0.1)", // Gölge efekti
              }}
            >
              <Grid container sx={{ marginTop: "0%", alignItems: "center" }}>
                <Grid item xs={3}>
                  <Typography
                    sx={{
                      flexDirection: "row",
                      display: "flex",
                      gap: 1,
                      width: "90%",
                    }}
                  >
                    <Typography sx={{ fontWeight: "700" }}>
                      {" "}
                      {taxPayerData?.title}
                    </Typography>{" "}
                  </Typography>
                </Grid>
                <Grid item xs={2}>
                  <Grid
                    sx={{
                      display: { lg: "flex", xl: "flex" },
                    }}
                  >
                    <Typography>
                      {taxPayerData?.tckn ? "TCKN : " : ""}
                    </Typography>
                    <Typography sx={{ fontWeight: "700" }}>
                      {" "}
                      {taxPayerData?.tckn}
                    </Typography>{" "}
                  </Grid>

                  <Grid
                    sx={{
                      display: taxPayerData?.tckn
                        ? {
                            xs: "none",
                            sm: "none",
                            md: "none",
                            lg: "flex",
                            xl: "flex",
                          }
                        : { lg: "flex", xl: "flex" },
                    }}
                  >
                    {taxPayerData?.vkn && (
                      <>
                        <Typography>VKN : </Typography>
                        <Typography sx={{ fontWeight: "700" }}>
                          {" "}
                          {taxPayerData?.vkn}{" "}
                        </Typography>
                      </>
                    )}
                  </Grid>
                </Grid>{" "}
                <Grid item xs={1.5}>
                  <Typography
                    sx={{
                      flexDirection: "row",
                      display: "flex",
                      gap: 1,
                      justifyContent: "center",
                    }}
                  >
                    Durumu:{" "}
                    <Typography
                      sx={{
                        fontWeight: "700",
                        color: taxPayerData.is_deleted ? "red" : "green",
                      }}
                    >
                      {" "}
                      {taxPayerData.is_deleted ? "Pasif" : "Aktif"}
                    </Typography>{" "}
                  </Typography>
                </Grid>
              </Grid>
            </Box>
          </Grid>

          <Grid
            className="ag-theme-quartz"
            style={{
              flex: 1,
              minHeight: "65vh",
              width: "100%",
              boxShadow: "rgba(0, 0, 0, 0.24) 0px 3px 8px",
              borderRadius: "10px", // İstediğiniz değeri buraya ekleyin
              overflow: "hidden", // Border-radius'in düzgün görünmesi için
            }}
          >
            <AgGridReact
              localeText={localeTextTr}
              rowSelection="multiple"
              rowData={data}
              columnDefs={ColumnDefs}
              enableRangeSelection={true}
              sideBar={gridSideBar}
              copyHeadersToClipboard={true}
              defaultColDef={defaultColDef}
              masterDetail={true}
              detailCellRendererParams={detailCellRendererParams}
              onGridReady={onGridReady}
              // onSelectionChanged={onSelectionChanged}
            />
          </Grid>
          <Grid
            item
            xs={12}
            sx={{
              justifyContent: "center",
              display: data?.length === 0 ? "none" : "flex",
              margin: "2% 0 2% 0",
              flexDirection: "row",
              alignItems: "center",
            }}
          >
            <Pagination
              count={totalPage}
              showFirstButton
              showLastButton
              page={currentPage}
              onChange={(event, value) => {
                setCurrentPage(value);
                window.scrollTo({ top: 0, behavior: "smooth" });
              }}
            />
            <TextField
              select
              value={pageSize}
              size="small"
              sx={{
                display: data && data?.length === 0 ? "none" : "block",
              }}
              onChange={(e) => {
                setCurrentPage(1);
                setPageSize(e.target.value);
                window.scrollTo({ top: 0, behavior: "smooth" });
              }}
            >
              <MenuItem value={50}>50</MenuItem>
              <MenuItem value={100}>100</MenuItem>
              <MenuItem value={250}>250</MenuItem>
            </TextField>
            <Typography sx={{ position: "absolute", right: "1%" }}>
              Toplam Kayıt : {totalCount}{" "}
            </Typography>
          </Grid>
          <Grid
            item
            xs={12}
            sx={{
              justifyContent: "space-between",
              display: rowData?.length === 0 ? "none" : "flex",
              margin: "2% 0 2% 0",
              alignItems: "center",
            }}
          >
            <NoteModal
              open={modalOpen}
              handleClose={() => {
                setModalOpen(false);
                setSelectedNote("");
                setSelectedRowId(null);
                setSelectedPdfData(null);
              }}
              note={selectedNote}
              id={selectedRowId}
              search={search}
              base64={selectedPdfData}
            />
            <Drawer
              open={openDrawer}
              anchor="right"
              onClose={() => setOpenDrawer(false)}
            >
              <FilterDrawer
                page={"taxpayer"}
                filters={filters}
                setFilters={setFilters}
                handleFetchData={search}
              />
            </Drawer>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
}

export default StatusWaitingTaxPayerPage;
